import { graphql } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { Loading } from '../../components/Loading';
import { NoData } from '../../components/Illustrations/NoData';
import { Versions as VersionsCmp } from '../../components/Versions';
import { useGraphQLQuery } from '../../hooks/useGraphQLQuery.hook';

export const ResolvableMissionTypeVersions_Versions_QueryDocument = graphql(`
  query ResolvableMissionTypeVersions_Versions_Query($originalId: Id!) {
    findAllResolvableMissionTypeVersionsForOneOriginalId(
      originalId: $originalId
    ) {
      _id
      createdAt
      creatorId
      automaticMemo
      internalMemo
      memo
      version {
        _id

        code
        codingConfig {
          kind
          strategyId
          ... on CodingConfigManual {
            code
          }
        }

        label
        title
        content
        serviceUsagesGroups {
          _id
          groupingMode
          index
          label
          serviceUsages {
            _id
            contentOriginId
            serviceUsageOrigin {
              missionTypeId
              serviceUsageId
            }
            serviceOriginId
            serviceId
            index
            serviceId
            specialService {
              title
              updatedAt
              updaterId
              value {
                discountAmount {
                  currencyId {
                    __typename
                    mode
                    resolverId
                    value
                  }
                  value {
                    __typename
                    mode
                    resolverId
                    value
                  }
                }
                discountPercentage {
                  __typename
                  mode
                  resolverId
                  value
                }
                priceExcludingVat {
                  currencyId {
                    __typename
                    mode
                    resolverId
                    value
                  }
                  value {
                    __typename
                    mode
                    resolverId
                    value
                  }
                }
                vatId {
                  __typename
                  mode
                  resolverId
                  value
                }
              }
              code
              codingConfig {
                kind
                strategyId
                ... on CodingConfigManual {
                  code
                }
              }
              content
              costUsages {
                costId
                index
                quantity {
                  unitId
                  value
                }
              }
              createdAt
              creatorId
              label
              materialUsages {
                index
                materialId
                quantity {
                  unitId
                  value
                }
              }
              statusId
            }
            settings {
              showAmountsInQuotation {
                __typename
                mode
                resolverId
                value
              }
              showCostsInQuotation {
                __typename
                mode
                resolverId
                value
              }
              showMaterialsInQuotation {
                __typename
                mode
                resolverId
                value
              }
              showQuantitiesInQuotation {
                __typename
                mode
                resolverId
                value
              }
            }
            quantity {
              value {
                __typename
                mode
                resolverId
                value
              }
              unitId {
                __typename
                mode
                resolverId
                value
              }
            }
          }
        }
        reportTemplateIds
        quotationTemplateId
        allowedFileCategoryIds
        enabledToolkitIds
        statusId
        creatorId
        createdAt
        updaterId
        updatedAt
      }
    }
  }
`);

interface Props {
  readonly originalId: Id;
}

export const Versions = ({ originalId }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    ResolvableMissionTypeVersions_Versions_QueryDocument,
    { originalId },
    { enabled: !!originalId },
  );

  if (!isSuccess) {
    return <Loading />;
  }

  const versions = data.findAllResolvableMissionTypeVersionsForOneOriginalId;

  if (!versions.length) {
    return <NoData />;
  }

  return <VersionsCmp versions={versions} />;
};
